import { AdminUserActions, LOAD_ADMIN_USER_LIST, CREATE_USER_INVITE, LOAD_ALL_USERS } from 'action-creators/adminUser';
import { RESET } from 'action-creators/generic';
import { AdminUser } from 'models/adminUser';

export interface AdminUserState {
  adminUserList: AdminUser[];
  allUsersAndInvited: AdminUser[];
  allUsers: AdminUser[];
}

const initialState: AdminUserState = {
  adminUserList: [],
  allUsersAndInvited: [],
  allUsers: [],
};

const reducer = (state = initialState, action: AdminUserActions): AdminUserState => {
  switch (action.type) {
    case LOAD_ADMIN_USER_LIST: {
      return {
        ...state,
        adminUserList: action.adminUserList,
      };
    }
    case CREATE_USER_INVITE: {
      return {
        ...state,
        adminUserList: state.adminUserList.concat(action.user),
      };
    }
    case LOAD_ALL_USERS: {
      return {
        ...state,
        adminUserList: action.allUsers,
      };
    }
    case RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
